// @ts-nocheck
import React from 'react';
// material
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import TaxNumberField from '../../../commons/components/TaxNumberField';
import ButtonWithLoader from '../../../commons/containers/ButtonWithLoader';

function SupplierForm({
  // props
  controls,
  changeControls,
  edit,
  invalidControls,
  isOpen,
  onChange,
  submit,
  toggleForm,
  country,
  hasSchedulePermission,
}) {
  const { t } = useTranslation();
  
  return (
    <Dialog fullWidth onClose={toggleForm} aria-labelledby="simple-dialog-title" open={isOpen}>
      <DialogTitle>{edit ? t('Edit supplier') : t('Create supplier')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.name}
              onChange={changeControls}
              fullWidth
              id="name"
              label={t('Name')}
              error={invalidControls.name}
              helperText={invalidControls.name && t('Name required')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TaxNumberField
              value={controls.taxNumber}
              onChange={onChange}
              fullWidth
              error={invalidControls.taxNumber}
              helperText={invalidControls.taxNumber && t('identifier.validate_message')}
              country={country}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.email}
              onChange={changeControls}
              fullWidth
              id="email"
              label={t('Email')}
              error={invalidControls.email}
              helperText={invalidControls.email && t('Email required')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.code}
              onChange={changeControls}
              fullWidth
              id="code"
              label={t('Code')}
              // error={invalidControls.code}
              // helperText={invalidControls.email && 'Debe ingresar un email'}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.region}
              onChange={changeControls}
              fullWidth
              id="region"
              label={t('Region')}
              // error={invalidControls.email}
              // helperText={invalidControls.email && 'Debe ingresar un email'}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.province}
              onChange={changeControls}
              fullWidth
              id="province"
              label={t('Province')}
              // error={invalidControls.email}
              // helperText={invalidControls.email && 'Debe ingresar un email'}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.sector}
              onChange={changeControls}
              fullWidth
              id="sector"
              label={t('Sector')}
              // error={invalidControls.email}
              // helperText={invalidControls.email && 'Debe ingresar un email'}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={controls.phone}
              onChange={changeControls}
              fullWidth
              placeholder={hasSchedulePermission ? '+56987654321' : ''}
              id="phone"
              label={t('Phone')}
              error={invalidControls.phone}
              helperText={hasSchedulePermission && invalidControls.phone && t('Phone format invalid')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          {hasSchedulePermission && (
            <Grid item sm={6} xs={12}>
              <TextField
                value={controls.companyName}
                onChange={changeControls}
                fullWidth
                id="companyName"
                label={t('Razón Social')}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleForm} color="primary">
          {t('CANCEL')}
        </Button>
        <ButtonWithLoader onClick={submit} autoFocus buttonId="create-edit-supplier">
          {edit ? t('Edit') : t('Add')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default SupplierForm;
